"use strict";

var isEmpty = require('lodash/isEmpty');

var defaultOffsetMillis = 25 * 60 * 1000; // 30 - 25 min = 5 refresh by flow.js

/**
 * Determine if a session is out of date. This is intended for use with the
 * Flow session's visit expiration date. It is set to 30 minutes after the
 * last update of the session.
 *
 * The `offset` parameter allows Flow.js to control how often to sync the
 * session with the API. For example to refresh the session every 5 minutes,
 * 25 minutes must be removed from the expected 30 minute life of the visit. The
 * offset defaults to 25 min (or 1500000 ms).
 *
 * @param {String} sessionVisitorExpiration The expiration of the session visit.
 *                   Format is the ISO 8601 standard
 * @param {Number} offset The offset in milliseconds by which to subtract from
 *                   expiration date to determine if session is out of date.
 *                   Default: 1500000ms
 */

function shouldRefreshSession(sessionVisitorExpiration) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffsetMillis;
  var now = Date.now();

  if (isEmpty(sessionVisitorExpiration)) {
    return true;
  }

  var expirationDate = new Date(sessionVisitorExpiration);
  return now >= expirationDate.getTime() - offset;
}

module.exports = shouldRefreshSession;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/session/lib/should-refresh-session.js
// module id = 695
// module chunks = 0 1